<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    document.body.style.zoom = this.golobleObject.zoom
  },
  mounted () {}
}
</script>

<style>
@import "common/common.css";
@import 'common/font/font.css';
</style>
<!--<style rel="stylesheet/less">-->
<!--  .el-cascader-panel .el-radio{-->
<!--    width: 100%;-->
<!--    height: 100%;-->
<!--    z-index: 10;-->
<!--    position: absolute;-->
<!--    top: 10px;-->
<!--    right: 10px;-->
<!--  }-->
<!--  .el-cascader-panel .el-radio__input{-->
<!--    visibility: hidden;-->
<!--  }-->
<!--  .el-cascader-panel .el-cascader-node__postfix {-->
<!--    top: 10px;-->
<!--  }-->
<!--</style>-->



// WEBPACK FOOTER //
// src/App.vue